import React from 'react';

import Link from '@components/link/Link.tsx';
import getUserName from '@functions/getUserName.ts';
import ReferralLinkT from '@global/models/ReferralLink.ts';

import { RenderColsT } from '../../types.ts';

const renderReferralLinks: RenderColsT<'referralLinks'> = function ({ name: colName, item }) {
    let content;
    let className;
    const referralLink = item as ReferralLinkT;

    if (colName === 'link') {
        content = <div className="v2table__text">/{referralLink.link}</div>;
    }

    if (colName === 'executor') {
        className = '_innerCol';

        content = (
            <div className="v2table__colInner">
                <div className="v2table__text _block">
                    <Link
                        className="v2table__text _link _full"
                        pageName="manual-executors-inner-main"
                        ids={{ 3: referralLink.exId }}
                    >
                        {getUserName({ user: referralLink.executor })}
                    </Link>
                </div>

                <div className="v2table__text _block">
                    <Link
                        className="v2table__text _link"
                        pageName="referral-main-inner"
                        ids={{ 3: referralLink.refId }}
                    >
                        Акция «{referralLink.referral.title}»
                    </Link>
                </div>
            </div>
        );
    }

    if (colName === 'count') {
        content = <div className="v2table__text">{referralLink.count}</div>;
    }

    if (colName === 'status') {
        let statusClassName = '_wait';

        if (referralLink.referral.status === 'active') {
            statusClassName = '_active';
        }

        content = (
            <div className={`v2table__status _block ${statusClassName}`}>
                {referralLink.referral.statusText}
            </div>
        );
    }

    return { content, className };
};

export default renderReferralLinks;
